/* Custom scrollTo JS for older iOS support */
(function () {
  if (window.__anchorScrollAttached) return;
  window.__anchorScrollAttached = true;

  function scrollToHash(hash, smooth) {
    if (!hash || hash.length < 2) return;
    var target = document.querySelector(hash);
    if (!target) return;
    var offset = 81;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
  }

  // In-page anchor clicks
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href === '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    scrollToHash(href, true);
  });

  // Page loaded with a hash already in URL
  if (window.location.hash) {
    // Wait a tick so the browser's native jump completes first, then correct it
    window.addEventListener('load', function () {
      scrollToHash(window.location.hash, false);
    });
  }
})();
